import { Box, Typography, Button, TableHead, TableBody, Table, TableContainer, TableCell, TableRow, TablePagination, InputAdornment, IconButton, TextField, } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./LoanLimitHistory.scss";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { commonRunQuery } from "../../util/API/loans";
import SearchIcon from "@mui/icons-material/Search";

const LoanLimitHistory = ({ setViewLimitHistory, selectedProductLoan, selectedUser }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [loanLimit, setLoanLimit] = useState([]);
    const [allLoanLimit, setAllLoanLimit] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchText, setSearchText] = useState("");

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            // backgroundColor: "rgba(0,0,0, .1)",
            color: theme.palette.common.black,
            fontWeight: "bold",
            textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 25,
            fontWeight: "600",
        },
    }));

    useEffect(()=> {
        console.log("selectedProductLoan----------",selectedProductLoan);
        getLimitHistory();
    },[]);

    const getLimitHistory = async() => {
        try {
            const response = await commonRunQuery(248, `${selectedUser}/${selectedProductLoan?.productcode}`);
            if(response?.data?.header?.callStatus == "1" && response?.data?.header?.reccount !== "0") {
                const limitHistoryArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                console.log("limitHistoryArray-------------",limitHistoryArray);
                setLoanLimit(limitHistoryArray);
                setAllLoanLimit(limitHistoryArray);
            } else {
                setLoanLimit([]);
                setAllLoanLimit([]);
            }
        } catch (error) {
            console.log("getLimitHistory_error-------------",error);
            setAllLoanLimit([]);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = async() => {
        if (!searchText.trim()) {
            setLoanLimit(allLoanLimit); // Reset to original data if search is cleared
            return;
        }
        const filteredLoans = allLoanLimit.filter((row) => {
            return (
                row?.loanlimitshistory?.curr.includes(searchText.toUpperCase()) ||
                row?.loanlimitshistory?.changeid?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanlimitshistory?.changedate?.toString().includes(searchText) ||
                row?.loanlimitshistory?.fromlimit?.toString().includes(searchText) ||
                row?.loanlimitshistory?.tolimit?.toString().includes(searchText) ||
                row?.loanlimitshistory?.comment?.toString().includes(searchText)
            );
        });
        console.log("filteredLoans----------",filteredLoans)
        setLoanLimit(filteredLoans);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    return (
        <Box>
            {
                isLoading ? 
                    (
                        <div className="text-center mt-5">
                            <span className="loader" />
                        </div>
                    ) :
                <>
                    <Box className="d-flex justify-content-between">
                        <Typography
                            sx={{
                                fontFamily: "'Nunito'",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "21.4825px",
                                color: "#3A3A3A",
                            }}
                            className=""
                        >
                            Limit History
                        </Typography>
                        <Box>
                            <Button
                                className="fs-size-12 paiy-blue text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => setViewLimitHistory(false)}
                            >
                                Return
                            </Button>
                        </Box>

                    </Box>
                    
                    <Box className="mt-4">

                        <Box className="search-container mb-4">
                            <TextField
                                placeholder=""
                                value={searchText}
                                onChange={handleInputChange}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        handleSearch(); 
                                    }
                                }}
                                variant="standard"
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    sx: {
                                        borderRadius: "33px",
                                        color: "#000",
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleSearch} edge="end">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {},
                                    "& .MuiInputBase-input": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </Box>
                        <TableContainer className="approved-loans-table-container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Currency Code</StyledTableCell>
                                        <StyledTableCell>Change Id</StyledTableCell>
                                        <StyledTableCell>Change Date</StyledTableCell>
                                        <StyledTableCell>From Limit</StyledTableCell>
                                        <StyledTableCell>To Limit</StyledTableCell>
                                        <StyledTableCell>Comment</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    // loanList && loanList.length > 0 && loanList.map((row, index) => (
                                    loanLimit && loanLimit.length > 0 && loanLimit.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">{row?.loanlimitshistory?.curr == "" ? "-" : row?.loanlimitshistory?.curr}</TableCell>
                                            <TableCell align="center">{row?.loanlimitshistory?.changeid}</TableCell>
                                            <TableCell align="center">{row?.loanlimitshistory?.changedate}</TableCell>
                                            <TableCell align="right">{Number(row?.loanlimitshistory?.fromlimit).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right">{Number(row?.loanlimitshistory?.tolimit).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="center">{row?.loanlimitshistory?.comment  == "" ? "-" : row?.loanlimitshistory?.comment}</TableCell>
                                        </TableRow>
                                    ))
                                }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={loanLimit?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Box>
                </>
            }
        </Box>
    )
}

export default LoanLimitHistory;